require('./prtv-interface-3.scss');

import DemandeActions from '../../../../actions/demande.actions';
import ChainesLocalesRepository from '../../../../repositories/chaines-locales.repository';
import { STEPS } from '../../../../utils/routes.util';
import { MAUVAISE_INSTABLE_BONNE_EXCELLENTE } from '../../../common/model';
import { PERTURBATIONS } from '../../../common/model';
import { OTHER_VALUE } from '../../model';

export default class PrtvInterface3Component {
  constructor() {
    this.controller = PrtvInterface3Controller;
    this.template = require('./prtv-interface-3.html');
  }
}

// @ngInject
class PrtvInterface3Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE = MAUVAISE_INSTABLE_BONNE_EXCELLENTE;
    this.PERTURBATIONS = PERTURBATIONS;
    this.OTHER_VALUE = OTHER_VALUE;
    this.containsStations = false;
    this.data = {
      connexionQuality: '',
      isContinue: false,
      channels: {},
      receivedStation: '',
      otherSelectedStationName: '',
      isNoOrientation: false,
      perturbationsValue: '',
      validStation: '',
    };
    this.$scope.$watch(() => this.data.receivedStation, () => this.handleOtherStation());
    this.$scope.$watch(() => this.data.otherSelectedStationName, () => this.handleOtherStation());
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_3));
    // Connexion au state récupérer les données modifiées
    this.alreadyFetched = false;

    const disconnect = this.$ngRedux.connect(
      state => {
        if (!this.alreadyFetched) {
          if (state.demande.data.prtvInterface2 !== undefined) {
            this.alreadyFetched = true;
            this.fetchChainesPrtvSuivi(state.demande.data);
          }
        }
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface3 ? state.demande.data.prtvInterface3.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  fetchChainesPrtvSuivi(demande) {
    if (demande.accueilInterface2) {
      const adresse = demande.accueilInterface2.adresse.commune.nom;
      const codeinsee = demande.accueilInterface2.adresse.commune.insee;
      this.callChainesLocales(adresse, codeinsee);
    }
    if (demande.informationsSuivi) {
      const adresse = demande.informationsSuivi.nomCommune;
      const codeinsee = demande.informationsSuivi.inseeCommune;
      this.callChainesLocales(adresse, codeinsee);
    }
  }

  callChainesLocales(adresse, codeinsee) {
    ChainesLocalesRepository.getChainesLocales(adresse, codeinsee)
        .then((response) => {
          this.containsStations = (response.data && response.data[0].station.length > 0);
          this.creerTableauSitesStations(response);
        });
  }

  handleOtherStation() {
    if (this.data.receivedStation === OTHER_VALUE) {
      this.data.validStation = this.data.otherSelectedStationName;
    } else {
      this.data.validStation = this.data.receivedStation;
    }
  }

  creerTableauSitesStations(response) {
    //data des sites et des stations
    const site = response.data[0].site;
    const station = response.data[0].station;
    let siteMap = site.map(name => ({
      name: name
    }));
    let stationMap = station.map(name => ({
      name: name,
      switchValue: false
    }));
    this.data.channels = {station: [...stationMap], site: siteMap};
  }

  onChangeConnexionQuality() {
    this.data.isContinue = (this.data.connexionQuality === this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.BONNE ||
      this.data.connexionQuality === this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.EXCELLENTE);
  }

  onChangeButtonNoOrientation() {
    this.data.otherSelectedStationName = '';
  }

  onChangeInputOtherStation() {
    this.data.isNoOrientation = false;
  }

  onClickStationButton() {
    this.data.isNoOrientation = false;
    this.data.otherSelectedStationName = '';
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface3(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface3(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-3/prtv-interface-3.component.js